import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileSizePipe } from './fileSize';
import { BooleanPipe } from './boolean';
import { BankCardPipe } from './bankCard.pipe';
import { SafeImageLoaderPipe } from './safeImageLoader.pipe';
import { ArraySplitOdd } from './splitOdd';
import { ArraySortingPipe } from './arraySorting.pipe';
import { RangeToArrayPipe } from './ranteToArray.pipe';
import { DateTzPipe } from './dateTz.pipe';
import { GigabytePipe } from './gigabyte.pipe';

let PIPES = [
    FileSizePipe,
    BooleanPipe,
    BankCardPipe,
    SafeImageLoaderPipe,
    ArraySortingPipe,
    RangeToArrayPipe,
    ArraySplitOdd,
    DateTzPipe,
    GigabytePipe
]


@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        ...PIPES,
        DateTzPipe
    ],
    exports: [
        ...PIPES
    ]
})
export class PipeModule { }
